<template>
    <div class="top-bar-wrapper" id="top-bar">
        <div class="top-bar">
            <router-link :to="{name: 'Index'}" class="logo">
                <Logo/>
            </router-link>
            <ul class="top-nav">
                <li><a href='/#about'><span v-html="$ml.with('VueJS').get('aboutService')"></span></a></li>
                <li><a href="/#functional"><span v-html="$ml.with('VueJS').get('functional')"></span></a></li>
                <li><a href="/#subscription"><span v-html="$ml.with('VueJS').get('subscription')"></span></a></li>
                <li><a href="#contacts"><span v-html="$ml.with('VueJS').get('contacts')"></span></a></li>
            </ul>

            <div class="top-bar-right">
                <div class="top-bar-btns">
                    <button class="button" v-on:click="redirect" v-bind:class="{'modal-auth':!userLoggedIn}">
                        <span class="button__icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z"
                                                                                              fill="none"/><path
                                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"
                                    fill="#000"/></svg>
                        </span>
                        <span v-on:click="redirect" v-if="userLoggedIn" class="button__text" v-html="$ml.with('VueJS').get('cabinet')"></span>
                        <span v-else class="button__text" v-html="$ml.with('VueJS').get('signIn')"></span>
                    </button>
                </div>

                <div class="lang-switcher">
                    <div class="lang-switcher-inner">
                        <div @click="$ml.change('russian'); changeValidationLocale(); changeUserLanguage()"
                             v-bind:class="{'selected':$ml.current === 'russian'}">РУ
                        </div>
                        <div @click="$ml.change('english'); changeValidationLocale(); changeUserLanguage()"
                             v-bind:class="{'selected':$ml.current === 'english'}">EN
                        </div>
                    </div>
                </div>

                <div class="menu-toggler">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M0 0h24v24H0V0z" fill="none"/>
                        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" class="hamb"/>
                    </svg>

                    <div class="nav-mob-wrapper">
                        <ul class="nav-mob">
                            <li><a href='/#about'><span v-html="$ml.with('VueJS').get('aboutService')"></span></a></li>
                            <li><a href="/#functional"><span v-html="$ml.with('VueJS').get('functional')"></span></a></li>
                            <li><a href="/#subscription"><span v-html="$ml.with('VueJS').get('subscription')"></span></a></li>
                            <li><a href="#contacts"><span v-html="$ml.with('VueJS').get('contacts')"></span></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

    import Logo from "./icons/Logo";
    import {Validator} from 'vee-validate';



    export default {
        name: 'Header',
        components: {Logo},


        computed: {
            userLoggedIn() {
                let token = this.$store.getters.token;
                return !!token && token.length > 0;
            }
        },

        mounted() {


            $(window).scroll(function () {
                $('.top-bar-wrapper').toggleClass('scrolled', $(this).scrollTop() > 10);
            });

            // nav
            $('.menu-toggler').click(function () {
                $('.nav-mob-wrapper').fadeToggle(200);
            });
            $('.nav-mob-wrapper ').click(function () {
                $('.nav-mob-wrapper').fadeOut(200);
            });

            $(document).mouseup(function (e) {
                var container = $('.menu-toggler');
                if (container.has(e.target).length === 0) {
                    // container.hide();
                    $('.nav-mob-wrapper').hide();
                }
            });


            $('.modal-auth').on('click', function (e) {
                e.preventDefault();
                $('.window-wrapper.window-reg').removeClass('window-open');
                $('.window-wrapper.window-auth').addClass('window-open');
                $('body').addClass('blocked');
            });

            $('.modal-reg').on('click', function (e) {
                e.preventDefault();
                $('.window-wrapper.window-auth').removeClass('window-open');
                $('body').addClass('blocked');
                $('.window-wrapper.window-reg').addClass('window-open');
            });

            $('.modal-forgot').on('click', function (e) {
                e.preventDefault();
                $('.window-wrapper.window-auth').removeClass('window-open');
                $('body').addClass('blocked');
                $('.window-wrapper.window-forgot').addClass('window-open');
            });

            // lang-switcher
            $('.lang-switcher-inner div').click(function () {
                if ($(this).parent().hasClass('view')) {
                    $(this).parent().removeClass('view');
                    $(this).siblings().removeClass('selected');
                    $(this).addClass('selected');
                } else {
                    $(this).parent().addClass('view');
                }
            });
        },

        methods: {
            redirect() {
                if (!this.userLoggedIn) {
                    ym(80365885,'reachGoal','Signln');
                    return;
                }
                let userRole = this.$store.getters.currentUser.role;
                if (['ROLE_ADMIN'].includes(userRole)) {
                    this.$router.push({name: 'Clients'});
                } else {
                    this.$router.push({name: 'ClientMails'});
                }
            },

            changeValidationLocale() {
                Validator.localize('en', this.$ml.get('errors'));
                Validator.localize('en');
            },

            changeUserLanguage() {
                if (!this.userLoggedIn) {
                    return;
                }
                this.$store.dispatch('changeLanguage', this.$ml.current);
            }
        }
    }
</script>